// The tones of the documents' notices, one definition for the banners over a
// document and the warnings of the new-document dialog: the theme has no
// warning or info token.
export const NOTICE_TONES = {
	sky: 'border-sky-400/50 bg-sky-50 text-sky-900 dark:bg-sky-950 dark:text-sky-200',
	amber: 'border-amber-400/50 bg-amber-50 text-amber-900 dark:bg-amber-950 dark:text-amber-200'
}
